import { render, staticRenderFns } from "./CheckoutModalTrigger.vue?vue&type=template&id=5f2cd817&"
import script from "./CheckoutModalTrigger.vue?vue&type=script&lang=js&"
export * from "./CheckoutModalTrigger.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutModalTrigger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports